export default "__VITE_ASSET__e437fd70__"